/**
 * CORE-1829 — a 403 that a token refresh cannot change.
 *
 * `authedRequest` answers every 401/403 with one refresh + retry, because a
 * `[Authorize(Roles=…)]` 403 can come from a JWT minted before the role was
 * granted. A Live-session capability refusal (`code: capability_required`) is
 * not that: it reads the session's frozen snapshot (CORE-544), which no token
 * carries. Retrying it only doubles the request and rotates the token for
 * nothing — on prod 24.10 every «передать управление» tap went out twice with a
 * refresh in between.
 *
 * Reads a clone, so the caller still parses the original body.
 */
export const CAPABILITY_REQUIRED_CODE = 'capability_required';

export async function isCapabilityRefusal(response: Response): Promise<boolean> {
    if (response.status !== 403 || typeof response.clone !== 'function') return false;
    try {
        const body = await response.clone().json();
        const code = body?.code ?? body?.Code;
        return code === CAPABILITY_REQUIRED_CODE;
    } catch {
        // Empty or non-JSON 403 — the role-claim kind; keep the retry.
        return false;
    }
}
